import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import { createApi } from '@reduxjs/toolkit/query/react'

import {
  PaymentControllerSendApiArg,
  PaymentControllerSendApiResponse,
  PaymentLinkControllerGetApiArg,
  PaymentLinkControllerGetApiResponse,
} from '@/app/model'

export const paymentApi = createApi({
  reducerPath: 'payment',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/pay`,
    prepareHeaders: (headers) => {
      headers.set('x-business-unit', `${process.env.REACT_APP_UN}`)
      return headers
    },
  }),
  tagTypes: ['payments'],
  endpoints: (build) => ({
    paymentLinkControllerGet: build.query<
      PaymentLinkControllerGetApiResponse,
      PaymentLinkControllerGetApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/payment-links/${queryArg.id}` }),
      providesTags: ['payments'],
    }),
    paymentControllerSend: build.mutation<
      PaymentControllerSendApiResponse,
      PaymentControllerSendApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/payments`,
        method: 'POST',
        body: queryArg.sendPaymentDto,
      }),
      invalidatesTags: ['payments'],
    }),
  }),
})

export const {
  usePaymentLinkControllerGetQuery,
  useLazyPaymentLinkControllerGetQuery,
  usePaymentControllerSendMutation,
} = paymentApi
